import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const getProducts = async () => {
    const response = await axios.get(`product`, {headers: authHeader()});
    return response.data.result;
};

const getProduct = async (productId) => {
    const response = await axios.get(`product/${productId}`, {headers: authHeader()});
    return response.data.result;
};

const updateProduct = async (productId, payload) => {
    const response = await axios.put(`product/${productId}`, payload, {headers: authHeader()});
    return response.data.result;
};

const addFee = async (productId, payload) => {
    await axios.post(`product/${productId}/fees`, payload, {headers: authHeader()});
};

const updateFee = async (productId, feeId, payload) => {
    await axios.put(`product/${productId}/fees/${feeId}`, payload, {headers: authHeader()});
};

const deleteFee = async (productId, feeId) => {
    await axios.delete(`product/${productId}/fees/${feeId}`, {headers: authHeader()});
};

export const productApi = {
    getProducts,
    getProduct,
    updateProduct,
    addFee,
    updateFee,
    deleteFee
};
